module.exports = __webpack_public_path__ + "media/images/top/seminars/template/image05-87aad5ab7ee825444d13fd6c25b6058f.jpeg";